// extracted by mini-css-extract-plugin
export var contacts = "Contacts-module--contacts--3rFuK";
export var item = "Contacts-module--item--3aZ8X";
export var link = "Contacts-module--link--2rGsi";
export var list = "Contacts-module--list--3gIi_";